import React from 'react'
import Layout from '../../Layout'
import CreatePrivateDiscountCodeContainer from './../../../../Components/DiscountPart/CreatePrivateDiscountCodeContainer/CreatePrivateDiscountCodeContainer';

const CreatePrivateDiscountCode = () => {
  return (
    <Layout><CreatePrivateDiscountCodeContainer/></Layout>
  )
}

export default CreatePrivateDiscountCode